import http from '@/api/HttpHelper'

const state = {
    customers: []
}

const getters = {
    customers (state) {
        return state.customers
    },
    customerById (state) {
        return id => state.customers.find(item => item.id == id)
    }
}

const mutations = {
    setCustomers (state, customers) {
        state.customers = customers
    }
}

const actions = {
    async getCustomers ({ commit, state }) {
        if (state.customers.length > 0)
            return
        
        var result = await http.get('branches')
        if (result.status === 200)
            commit('setCustomers', result.data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}